import React, { createContext, useState, useEffect } from 'react';
import { login as apiLogin, getProfile } from '../api/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          setLoading(true);
          const response = await getProfile();
          setCurrentUser(response.data.data);
          setIsAuthenticated(true);
        } catch (err) {
          console.error('Error verificando autenticación:', err);
          localStorage.removeItem('token');
          setCurrentUser(null);
          setIsAuthenticated(false);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
        setIsAuthenticated(false);
        setCurrentUser(null);
      }
    };

    checkAuth();
  }, []);

  const login = async (credentials) => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiLogin(credentials);
      localStorage.setItem('token', response.data.data.token);
      setCurrentUser(response.data.data.usuario);
      setIsAuthenticated(true);
      return response.data;
    } catch (err) {
      console.error('Error de inicio de sesión:', err);
      setError(err.response?.data?.message || 'Error al iniciar sesión. Verifica tus credenciales.');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setCurrentUser(null);
    setIsAuthenticated(false);
    window.location.href = '/login'; // Asegurar que redirige al login
  };

  const value = {
    currentUser,
    loading,
    error,
    isAuthenticated,
    login,
    logout,
    setError
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
